import axios from 'axios'
import config from '@/config'
import { getToken } from '@/libs/util'
const baseUrl =
  process.env.NODE_ENV === 'development'
    ? config.baseUrl.dev
    : config.baseUrl.pro

const stranges = {
  'queryPointListById': '/sys/project/queryPointListById/',
  'queryProjectList': '/sys/project/queryProjectList',
  'newProject': '/sys/project/newProject',
  'deleteProjectById': '/sys/project/deleteProjectById',
  'queryProjectByFilter': '/sys/project/queryProjectByFilter',
  queryProjectById: '/sys/project/queryProjectById/',
  fuzzyQueryProjectList: '/sys/project/fuzzyQueryProjectList'
}
export default function (method, apiname, params, path) {
  let data = params
  if (!path) {
    path = ''
  }
  return axios.request({
    method: method,
    url: baseUrl + stranges[apiname] + path,
    _headers: {
      // token:localStorage['token'],
      token: getToken(),
      'Content-Type': 'application/json; charset=utf-8'
    },
    get headers () {
      return this._headers
    },
    set headers (value) {
      this._headers = value
    },
    data: data
  })
}
